import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Documents from "./pages/Documents";
import Assets from "./pages/Assets";
import Projects from "./pages/Projects";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Notifications from "./pages/Notifications";
import Search from "./pages/Search";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import RelationshipGraph from "./pages/RelationshipGraph";
import Correspondence from "./pages/Correspondence";
import MailImport from "./pages/MailImport";
import BulkImport from "./pages/BulkImport";
import Transmittals from "./pages/Transmittals";
import AuditTrail from "./pages/AuditTrail";
import Contacts from "./pages/Contacts";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="documents" element={<Documents />} />
              <Route path="assets" element={<Assets />} />
              <Route path="projects" element={<Projects />} />
              <Route path="graph" element={<RelationshipGraph />} />
              <Route path="correspondence" element={<Correspondence />} />
              <Route path="transmittals" element={<Transmittals />} />
              <Route path="mail-import" element={<MailImport />} />
              <Route path="bulk-import" element={<BulkImport />} />
              <Route path="audit-trail" element={<AuditTrail />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="users" element={<Users />} />
              <Route path="roles" element={<Roles />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="search" element={<Search />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
